// extracted by mini-css-extract-plugin
export default {"item":"TodoItem_item__1oYro","checkbox":"TodoItem_checkbox__hbsVB","textInput":"TodoItem_textInput__N4INb"};